import React, { useEffect } from "react";
import Styled from "./styles";
import HealthPlans from "../PracticeInfo/HealthPlans";
import * as actions from "../../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const HealthPlansPNDS = () => {
  const dispatch = useDispatch();

  const { state } = useLocation();
  const { physicianId } = state;
  const healthPlans = useSelector(({ healthPlans }) => healthPlans?.data?.data);
  const logger = useSelector(({ logger }) => logger?.data);
  const noDataMessage = useSelector(
    ({ physicianProfileInfo }) => physicianProfileInfo?.dataMessage
  );
  useEffect(() => {
    if (!logger?.sessionId) {
      dispatch(actions.fetchLogger());
    } else {
      dispatch(
        actions.fetchHealthPlans(
          { physicianId: physicianId },
          { sessionId: logger?.sessionId }
        )
      );
    }
  }, [dispatch, logger?.sessionId, physicianId]);
  return (
    <Styled>
      <HealthPlans healthPlanContract={healthPlans?.healthPlanContract} 
      noDataMessage={noDataMessage} pndsHealthPlans={healthPlans?.pndsHealthPlans}
      />
    </Styled>
  );
};

export default HealthPlansPNDS;
